<div
  class="sidebar-wrap"
  [ngClass]="expanded ? 'sidebar-expanded' : 'sidebar-collapsed'"
>
  <kendo-drawer-container>
    <kendo-drawer
      #drawer
      [items]="menuItems"
      mode="push"
      [miniWidth]="76"
      [mini]="true"
      [width]="282"
      [autoCollapse]="false"
      [(expanded)]="expanded"
    >
      <ng-template kendoDrawerHeaderTemplate>
        <div class="sidebar-header sidebar-toggle-container"
          role="button"
          (click)="drawerToggle(drawer)"
        >
          <div class="sidebar-toggle user-select-none">
            <div class="w-100 d-flex d-lg-none align-items-center justify-content-between">
              <span class="mobile-menu-label fw-semibold">{{ "sidebarMenu.menu" | translate }}</span>
              <i class="app-icon icon icon-chevron-down icon-md2"></i>
            </div>

            <div class="d-none d-lg-flex align-items-center justify-content-between"
              [ngClass]="[expanded ? 'gap-3' : 'gap-2 flex-column']"
            >
              <div class="flex-grow-1 sidebar-logo-container"
                [ngClass]="{'logo-mini' : !expanded}"              
              >
                <div class="sidebar-logo"></div>
              </div>
              <i class="app-icon icon icon-back-to-top icon-lg p-2"></i>
            </div>
          </div>  
        </div>
      </ng-template>

      <ng-template kendoDrawerItemTemplate let-item>
        <div *ngIf="item.features && item.features.length > 0; then hasChildren; else noChildren"></div>

        <ng-template #hasChildren>
          <div ngbAccordion (click)="expandHandler(drawer)" 
            class="flex-grow-1 sub-menu-items-accordion" [closeOthers]="true">
            <div ngbAccordionItem="accordionItem" 
              #accordionItem="ngbAccordionItem" 
              id="panel-{{item.menuItemId}}" 
              class="menu-item">
              <div ngbAccordionHeader>
                <div ngbAccordionToggle class="k-drawer-link no-children d-flex align-items-center" 
                  [ngClass]="{'justify-content-center': !drawer.expanded}"
                  [ngbTooltip]="templateMenuItemTooltipChildren" 
                  [disableTooltip]="drawer.expanded" 
                  placement="right" 
                  tooltipClass="menu-item-tooltip"
                  container="body"
                >
                  <i class="menu-item-icon app-icon icon icon-{{item.icon}} icon-xl"></i>

                  <div *ngIf="drawer.expanded" class="drawer-item-box flex-grow-1">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="drawer-item-width">
                        {{item.name}}
                      </span>
                      <div class="accordion-toggle-button ms-auto" [ngClass]="{'collapsed' : accordionItem.collapsed}">
                        <i class="app-icon icon icon-chevron-up icon-md"></i>
                      </div>
                    </div>
                  </div>
                </div>       
              </div>        
                
              <div ngbAccordionCollapse>
                <div ngbAccordionBody>
                  <ng-template>
                    <div *ngFor="let children of item.features" class="sub-menu-item">
                      <div class="k-drawer-link child-name" (click)="redirectMenu(children.path)">
                        <div class="flex-grow-1 d-flex flex-column">
                          <span class="drawer-item-title childless-btn">{{ children.name | translate}}</span>
                          <span class="item-descr" *ngIf="item.description">
                            {{ children.description }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>      
            </div>
          </div>
        </ng-template>

        <ng-template #noChildren>
          <div
            id="{{ item.menuItemId }}"
            class="menu-item"
            (click)="expandHandler(drawer)"
            [ngbTooltip]="templateMenuItemTooltip"
            [disableTooltip]="drawer.expanded"
            placement="right"
            tooltipClass="menu-item-tooltip"
            container="body"
          >
            <div class="k-drawer-link no-children d-flex align-items-center"
              [ngClass]="{'justify-content-center': !drawer.expanded}"
              (click)="redirectMenu(item.path)"
            >
              <i class="menu-item-icon app-icon icon icon-{{item.icon}} icon-xl"></i>

              <div *ngIf="drawer.expanded" class="flex-grow-1 d-flex flex-column">
                <span class="drawer-item-title childless-btn">
                  {{ item.name | translate }}
                </span>
                <span *ngIf="item.description" class="item-descr">
                  {{ item.description }}
                </span>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template #templateMenuItemTooltipChildren>
          <div class="tooltip-menuitem-box tooltip-menuitem-box-childrens">
            <span class="tooltip-menuitem-label-childrens">{{ item.name }}</span>
          </div>
        </ng-template>

        <ng-template #templateMenuItemTooltip>
          <div class="tooltip-menuitem-box">
            <span class="tooltip-menuitem-label">{{ item.name }}</span>
          </div>
        </ng-template>
      </ng-template>

      <ng-template kendoDrawerFooterTemplate>
        <div class="sidebar-footer mt-3 d-none d-lg-block">
          <div class="sidebar-user-menu d-none d-lg-flex align-items-center fw-semibold cursor-pointer gap-2" 
            [autoClose]="true" 
            [ngbPopover]="settingsActions" 
            placement="top-left" 
            container="body"
            popoverClass="popover-no-arrow user-menu-popover"
          >
            <app-user-badge 
              badgeTheme="2"
              [username]="username" 
              [width]="40" 
              [height]="40" 
              fontSize="16px">
            </app-user-badge>

            <span HJSuppress class="username-label flex-grow-1 me-2"
              [ngClass]="{'d-none' : !drawer.expanded}"
            >{{username}}</span>
            <i class="app-icon icon icon-chevron-down icon-md"
              [ngClass]="{'d-none' : !drawer.expanded}"
            ></i>
          </div>
        </div>
      </ng-template>
    </kendo-drawer>
  </kendo-drawer-container>
</div>

<ng-template #settingsActions>
  <div class="actions-box d-flex flex-column gap-2">
    <button class="btn actions-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.MY_PROFILE)">
      <i class="app-icon icon icon-user icon-lg"></i>
      <span>{{'headerMenu.myProfile' | translate}}</span>
    </button>
    <button *ngIf="showAppVersion" class="btn actions-btn" 
      (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.ABOUT)">
      <i class="app-icon icon icon-warning-circle icon-lg"></i>
      <span>{{'headerMenu.about' | translate}}</span>
    </button>
    <button *ngIf="isAdmin" class="btn actions-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.MY_CSS)">
      <i class="app-icon icon icon-settings icon-lg"></i>
      <span>{{'headerMenu.settingsActions.cssFile' | translate}}</span>
    </button>
    <button class="btn actions-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.LANGUAGE_SWITCHER)">
      <i class="app-icon icon icon-world icon-lg"></i>
      <span>{{'common.selectLanguage' | translate}}</span>
    </button>
    <button class="btn actions-btn" (click)="onUserNavOptionSelect(USER_NAV_ACTIONS.LOGOUT)">
      <i class="app-icon icon icon-log-out icon-lg"></i>
      <span>{{'headerMenu.logout' | translate}}</span>
    </button>
  </div>
</ng-template>
